import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { StandardLayout } from 'common/layouts/StandardLayout'
import { OrganizationsSearch } from './OrganizationsSearch'
import { ExperiencesBillingContainer } from './ExperiencesBilling'
import { OrganizationCollections } from './OrganizationCollections'
import { OrganizationChallenges } from './OrganizationChallenges'

const AppWrapper = ({ children }) => (
  <StandardLayout greyBg>
    {children}
  </StandardLayout>
)

export const routes = ({ match: { path } }) => (
  <Switch>
    <Route path={`${path}/search`} render={() => <AppWrapper><OrganizationsSearch /></AppWrapper>} />
    <Route path={`${path}/:organizationId/experiences_billing`} render={() => <AppWrapper><ExperiencesBillingContainer /></AppWrapper>} />
    <Route path={`${path}/:clubIdParam/challenges`} component={OrganizationChallenges} />
    <Route path={`${path}/:clubIdParam/collections`} component={OrganizationCollections} />
  </Switch>
)
